import { useGetTemplates } from '@modules/dashboard/hooks/useGetTemplates';
import { Skeleton, Stack, Typography } from '@mui/material';
import { DashboardTemplateListItem } from './DashboardTemplateListItem';

export const DashboardTemplatesList = () => {
  const { templates, loading } = useGetTemplates();

  if (loading || !templates) {
    return (
      <Stack spacing={1}>
        {[...Array(3)].map(() => (
          <Skeleton variant="rectangular" height={84} />
        ))}
      </Stack>
    );
  }

  if (templates.length === 0) {
    return (
      <Typography variant="subtitle1" color="text.disabled">
        No templates found
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {templates.map((template) => (
        <DashboardTemplateListItem key={template.id} template={template} />
      ))}
    </Stack>
  );
};
